// 機械の状態管理
// recStartedSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AnyAction, Dispatch } from "redux";
import { appendAlert } from "../redux/alertSlice";
import apiAxios from "../utils/apiAxios";
import { formatDateTime } from "../utils/dateUtils";
import cloneDeep from "lodash/cloneDeep";
import { GetMachStatuses } from "../models/GetMachStatuses";
import { PostMachStatuses } from "../models/PostMachStatuses";

export const recMachStartedSlice = createSlice({
  name: "recMachStarted",
  initialState: {
    // 機械状況APIから取得したデータ
    machStatus: null as GetMachStatuses | null,
  },
  reducers: {
    setMachStatus: (state, action: PayloadAction<GetMachStatuses | null>) => {
      state.machStatus = action.payload;
    },
  },
});

const { setMachStatus } = recMachStartedSlice.actions;

// 機械状況の取得(API実行)
const fetchMachineStatus = (
  plant_code: String,
  proc_code: String,
  mach_code: String
) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    try {
      const response = await apiAxios.get<GetMachStatuses[]>(
        `/mach_statuses?plant_code=${plant_code}&proc_code=${proc_code}&mach_code=${mach_code}`
      );
      const data = response.data;
      console.log(data);
      if (data === null || data.length !== 1) {
        dispatch(setMachStatus(null));
      } else if (data.length > 0) {
        dispatch(setMachStatus(data[0]));
      }
    } catch (error: any) {
      console.error(error);
      dispatch(
        appendAlert({
          severity: "error",
          message: "データの取得に失敗しました。" + error.message,
          displayTime: 5000,
        })
      );
    }
  };
};

// 機械状況の更新(API実行)
const postMachineStatus = (
  machStatus: GetMachStatuses,
  status: 0 | 1,
  userId: string
) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    try {
      const newMachStatus = cloneDeep(machStatus);
      newMachStatus.status_code = status;
      newMachStatus.start_time = formatDateTime(new Date());
      const postDatas: PostMachStatuses[] = [
        {
          plant_code: newMachStatus.plant_code,
          proc_code: newMachStatus.proc_code,
          mach_code: newMachStatus.mach_code.toString(),
          timestamp: formatDateTime(new Date()),
          action: status === 1 ? "start" : "end",
          update_by: userId,
        },
      ];
      console.log(postDatas);
      const response = await apiAxios.post<PostMachStatuses>(
        `/mach_statuses`,
        postDatas
      );
      console.log(response);
      dispatch(setMachStatus(newMachStatus));
    } catch (error: any) {
      console.error(error);
      dispatch(
        appendAlert({
          severity: "error",
          message: "データの取得に失敗しました。" + error.message,
          displayTime: 5000,
        })
      );
    }
  };
};

export { fetchMachineStatus, postMachineStatus, setMachStatus };
export default recMachStartedSlice.reducer;
